import React from "react";
import { Link } from "react-router-dom";
import { FaExclamationTriangle } from "react-icons/fa";
import styles from "../../styles/components/common/PageStatusPanel.module.css";

/**
 * Shared empty / error recovery shell for full-page states.
 */
const PageStatusPanel = ({
  title,
  message,
  icon: Icon = FaExclamationTriangle,
  primaryAction,
  secondaryAction,
  role = "alert",
}) => (
  <div className={`pageContainer ${styles.shell}`}>
    <div className={`innerContainer ${styles.inner}`}>
      <div className={styles.panel} role={role}>
        <Icon className={styles.icon} aria-hidden="true" />
        <h1 className={styles.title}>{title}</h1>
        {message ? <p className={styles.message}>{message}</p> : null}
        {(primaryAction || secondaryAction) && (
          <div className={styles.actions}>
            {primaryAction?.to ? (
              <Link to={primaryAction.to} className={styles.primaryBtn}>
                {primaryAction.label}
              </Link>
            ) : primaryAction?.onClick ? (
              <button
                type="button"
                className={styles.primaryBtn}
                onClick={primaryAction.onClick}
              >
                {primaryAction.label}
              </button>
            ) : null}
            {secondaryAction?.to ? (
              <Link to={secondaryAction.to} className={styles.secondaryBtn}>
                {secondaryAction.label}
              </Link>
            ) : secondaryAction?.onClick ? (
              <button
                type="button"
                className={styles.secondaryBtn}
                onClick={secondaryAction.onClick}
              >
                {secondaryAction.label}
              </button>
            ) : null}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default PageStatusPanel;
